import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const classApi = {
  createClass: async (data: any): Promise<ApiResponse<any>> => {
    return axiosClient.post(`/class`, data);
  },
  getInforByCourseCode: async (courseCode: string) => {
    const res = await axiosClient.get(`/class/course/${courseCode}`);
    return res;
  },
  getAllClass: async (params: any) => {
    const res = await axiosClient.get(`/class`, {
      params,
    });
    return res;
  },
  getClassById: async (id: number) => {
    const res = await axiosClient.get(`/class/${id}`);
    return res;
  },
  deleteClass: async (id: number) => {
    const res = await axiosClient.delete(`/class/${id}`);
    return res;
  }
};

export default classApi;
